import { render, staticRenderFns } from "./community_longyou.vue?vue&type=template&id=45b0f0e4&scoped=true"
import script from "./community_longyou.vue?vue&type=script&lang=js"
export * from "./community_longyou.vue?vue&type=script&lang=js"
import style0 from "./community_longyou.vue?vue&type=style&index=0&id=45b0f0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b0f0e4",
  null
  
)

export default component.exports